/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel =
  (typeof ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel)[keyof typeof ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel];

export const ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel = {
  full: 'full',
  full_condensed: 'full_condensed',
  lite: 'lite',
  lite_condensed: 'lite_condensed',
  none: 'none',
} as const;
